import React from 'react';
import { Button } from '@/components/ui/button';

type MealPlanEmptyStateProps = {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  minHeight?: string;
};

const MealPlanEmptyState: React.FC<MealPlanEmptyStateProps> = ({
  title = 'No Meal Plan Found',
  description = 'Unable to load the meal plan.',
  actionLabel,
  onAction,
  minHeight = 'min-h-[400px]',
}) => (
  <div className={`flex items-center justify-center ${minHeight}`}>
    <div className="text-center">
      <div className="text-gray-400 mb-4">
        <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  </div>
);

export default MealPlanEmptyState;

